module.exports = __webpack_public_path__ + "static/media/los-angeles-thankyoufamily.68b72c05.jpg";